import React, { useState, useRef } from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import { useSettings } from '@wix/tpa-settings/react';
import { useResizeObserver } from '@react-hookz/web';
import { st, classes } from './Widget.st.css';
import { Header } from './Header/Header';
import { Body } from './Body/Body';
import { useWidgetViewModel } from '../hooks/useWidgetViewModel';
import Dialog from '../../../shared/components/Dialog/Dialog';
import ServiceDetailsDialog from '../../../shared/components/ServiceDetailsDialog/ServiceDetailsDialog';
import { FiltersModalDialog } from '../../../shared/components/Filters/FiltersModal/FiltersModalDialog';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useDatePicker } from '../hooks/useDatePicker';
import settingsParams from '../settingsParams';
import { Spinner } from '../../../shared/components/Spinner/Spinner';
import { HeaderDataHooks } from './Header/const';

export const Widget: React.FC = () => {
  const {
    isInitDataLoading,
    dialogViewModel,
    serviceDetailsViewModel,
    filtersViewModel,
    timeZoneViewModel,
  } = useWidgetViewModel();
  const { setHeaderSize } = useDatePicker();
  const settings = useSettings();
  const { isMobile, isRTL } = useEnvironment();
  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);
  const isHeaderSticky = settings.get(settingsParams.headerSticky);
  useResizeObserver(elementRef, (entry: ResizeObserverEntry) => {
    if (isHeaderSticky) {
      setHeaderSize({
        width: entry.contentRect.width,
        height: entry.contentRect.height,
      });
    }
  });

  return (
    <div
      className={st(classes.root, { isMobile, isRTL, isHeaderSticky })}
      dir={isRTL ? 'rtl' : 'ltr'}
      data-hook="DailyAgenda-wrapper"
    >
      {isFiltersModalOpen && (
        <FiltersModalDialog
          filtersViewModel={filtersViewModel}
          timeZoneViewModel={timeZoneViewModel}
          onClose={() => setIsFiltersModalOpen(false)}
        />
      )}
      <div
        className={classes.headerWrapper}
        id="daily-agenda-header-wrapper"
        ref={elementRef}
      >
        <Header onOpenFiltersModal={() => setIsFiltersModalOpen(true)} />
        <div className={classes.dividerWrapper}>
          <Divider className={classes.divider} />
        </div>
      </div>
      <Spinner
        className={classes.spinner}
        show={isInitDataLoading}
        dataHook={HeaderDataHooks.HeaderSpinner}
      />
      {!isInitDataLoading && <Body />}
      {dialogViewModel && <Dialog viewModel={dialogViewModel} />}
      {serviceDetailsViewModel.isOpen && (
        <ServiceDetailsDialog viewModel={serviceDetailsViewModel} />
      )}
    </div>
  );
};
